import { isClient } from '@/helpers/ClientSideRenderHelper'
import { LoyaltyCampaign } from '@/types'
import { useDefaultProperties } from './DefaultPropertiesHook'
import { logger } from '@/logging/Logger'

const log = logger()

export const useLoyaltyCampaign = (isDisplayErrors = false): LoyaltyCampaign | undefined => {
  const defaultProperties = useDefaultProperties(true)

  if (!defaultProperties?.loyaltyCampaign && isClient() && isDisplayErrors) {
    log.error('Loyalty campaign not found, useLoyaltyCampaign() returns undefined')
  }

  return defaultProperties?.loyaltyCampaign
}
